import { getWhatsAppUrlForPhone } from './whatsappContact.js';

/** Ubicación de la sede en Google Maps. */
export const OFFICE_MAPS_URL =
  'https://maps.google.com/maps?ll=4.627007,-74.115541&z=18&t=m&hl=es-ES&gl=US&mapclient=embed&cid=10936756677307297588';

export const OFFICE_LOCATION_LABEL = 'Cra. 58 #5C - 25 Bogotá D.C.';

export const OFFICE_EMAIL = 'gerencia@coonaltragas.com';

export const OFFICE_PHONE_DISPLAY = '(601) 4462466';

/** Líneas directas por área (celular Colombia). */
export const DEPARTMENT_CONTACT_LINES = [
  {
    label: 'Tesorería y cartera',
    display: '313 241 2067',
    telDigits: '3132412067',
    whatsappMessage: 'Hola, deseo contactar a Tesorería y cartera de Coonaltragas.',
  },
  {
    label: 'Área administrativa y servicios',
    display: '318 331 0518',
    telDigits: '3183310518',
    whatsappMessage: 'Hola, deseo contactar al Área administrativa y servicios de Coonaltragas.',
  },
];

export function getDepartmentWhatsAppHref(line) {
  const digits = line?.telDigits ?? line;
  const message = typeof line === 'object' ? line.whatsappMessage : undefined;
  return getWhatsAppUrlForPhone(digits, message);
}

/** Mapa embebido de Google Maps (sede principal). */
export const OFFICE_MAPS_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1988.4076815443466!2d-74.115541!3d4.627007!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f99563233b9a9%3A0x97c72a40a9c86f34!2sCra.%2058%20%235c-25%2C%20Bogot%C3%A1%2C%20Colombia!5e0!3m2!1ses!2sus!4v1779299525347!5m2!1ses!2sus';

/** Superintendencia de Economía Solidaria — entidad de vigilancia. */
export const SUPERSOLIDARIA_URL = 'https://www.supersolidaria.gov.co/';
export const SUPERSOLIDARIA_LOGO = '/supersolidaria.png';
export const SUPERSOLIDARIA_NAME = 'Superintendencia de Economía Solidaria';
